export default function limitValue(value, min, max) {
    return Math.max(Math.min(value, max), min);
}